export const SUPPLIER_FEEDBACK_BASE_API_PATH = '/supplier-feedback'

export const FEEDBACK_SCORE_CARD_COLUNMN_DEFS = [
    {
        title: 'Month',
        dataIndex: 'evaluation_period',
    },
    {
        title: 'Project',
        dataIndex: 'project_name',
    },
    {
        title: 'Overall Score',
        dataIndex: 'overall_score',
        align: 'center',
    },
    {
        title: 'Safety',
        dataIndex: 'Safety',
        align: 'center',
        width: 70,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Quality',
        dataIndex: 'Quality',
        align: 'center',
        width: 70,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Time Schedule',
        dataIndex: 'Time Schedule',
        align: 'center',
        width: 70,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Discipline & Compliance',
        dataIndex: 'Discipline & Compliance',
        align: 'center',
        width: 70,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Improvement & Initiative',
        dataIndex: 'Improvement & Initiative',
        align: 'center',
        width: 70,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
];

export const FEEDBACK_REPORT_COLUNMN_DEFS = [
    {
        title: 'Evauation Period',
        dataIndex: 'evaluation_period',
    },
    {
        title: 'Supplier',
        dataIndex: 'contractor_name',
        render: (text) => <p>{JSON.parse(text)['label']}</p>
    },
    {
        title: 'Overall Score',
        dataIndex: 'overall_score',
        width: 150,
        align: 'center',
    },
    {
        title: 'Safety',
        dataIndex: 'Safety',
        align: 'center',
        width: 150,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Quality',
        dataIndex: 'Quality',
        align: 'center',
        width: 150,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Time Schedule',
        dataIndex: 'Time Schedule',
        align: 'center',
        width: 150,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Discipline & Compliance',
        dataIndex: 'Discipline & Compliance',
        align: 'center',
        width: 150,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
    {
        title: 'Improvement & Initiative',
        dataIndex: 'Improvement & Initiative',
        align: 'center',
        width: 150,
        render: (text) => <p>{text.toFixed(2)}</p>
    },
];

export const FEEDBACK_LIST_COLUNMN_DEFS = [
    {
        headerName: "Id",
        width: 50,
        field: "id",
        editable: false,
        headerCheckboxSelection:true,
        checkboxSelection: true,
    },
    {
        headerName: "Contractor Name",
        width: 150,
        field: "contractor_name",
        editable: false,
        cellRenderer: "FeedbackListCellButton",
    },
    {
        headerName: "Project",
        width: 100,
        field: "project",
        editable: false,
    },
    {
        headerName: "Work Order No",
        width: 100,
        field: "work_order_no",
        editable: false,
    },
    {
        headerName: "Evaluation Period",
        width: 100,
        field: "evaluation_period",
        editable: false,
    },
    {
        headerName: "Project Head",
        width: 120,
        field: "project_head",
        editable: false,
    },
    {
        headerName: "Created at",
        width: 100,
        field: "created_date",
        editable: false,
    },
];